module.exports = __webpack_public_path__ + "static/media/collapsedAdd.34ecafc2.svg";